import API, { responseOf } from "./base";
import type { Executor } from "../features/task/components/execution/types/ExecutorModel";

export const byProcessId = (processId: string): Promise<Executor[]> =>
  responseOf(API.get(`/processes/${processId}/executors`));

export const create = (
  processId: string,
  executor: Executor,
): Promise<Executor> =>
  responseOf(API.post(`/processes/${processId}/executors`, executor));

export const update = (id: string, executor: Executor): Promise<Executor> =>
  responseOf(
    API.put(`/processes/${executor.process_id}/executors/${id}`, executor),
  );

export const remove = async (
  processId: string,
  executorId: string,
): Promise<void> => {
  await API.delete(`/processes/${processId}/executors/${executorId}`);
};
